import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { size as _size } from 'lodash';
import { i18nIntl, importCSS } from '../../lib/ep.js';

import ActionButton, { MainButton, SecondaryButton } from '../builder/ActionButton';
import ActionLink from '../builder/ActionLink';
import ButtonCollection from '../builder/ButtonCollection';
import CopyLink from '../builder/CopyLink';
import FieldLabel from '../builder/FieldLabel';
import FloatingLayer from '../builder/FloatingLayer';
import Input from '../builder/Input';
import Message from '../builder/Message';
import Model from '../builder/Model';
import SaveButton from '../builder/SaveButton';
import Select from '../builder/Select';
import SectionTitle from '../builder/SectionTitle';
import SectionSubtitle from '../builder/SectionSubtitle';

import SweepPostSelected from './SweepPostSelected';
import SweepSidebarBanners from './SweepSidebarBanners';

import { sweep as const_sweep } from './bootstrap';
import LinkCollection from '../ui_items/LinkCollection.js';

class SweepSidebar extends Component {
	constructor(props, context) {
		super(props, context);

		this.state = {
			already_selected_collaborator_network:false,
			display_added_posts_in_mobile:false,
			display_collaborator:false,
			display_multipost:false,
			display_popuppayment:false,
			display_sponsored_info:false,
			enable_next_in_mobile_layer:true,
			options_collaborator:{
				link:'',
				name_collaborator:'',
				network:false,
			},
			popuppayment_option:false,
			popuppayment_type:false,
			sweep:(props.sweep != undefined) ? props.sweep : {},
			type:(props.type != undefined) ? props.type : 'create',
		}
		
		this.display_posts = (props.display_posts != undefined) ? props.display_posts : true;
	}

	componentWillMount() {
		importCSS('comp/sweeps.css');
	}

	toggleAddedPostsInMobile(enable_next) {
		if(enable_next == undefined) enable_next = true;
		this.state.enable_next_in_mobile_layer = enable_next;
		this.state.display_added_posts_in_mobile = !this.state.display_added_posts_in_mobile;
		this.setState({...this.state});
	}

	toggleCollaborator() {
		this.state.already_selected_collaborator_network = false;
		this.state.display_collaborator = !this.state.display_collaborator;
		if(!this.state.display_collaborator) {
			this.state.options_collaborator = {};
			this.state.options_collaborator.link = '';
			this.state.options_collaborator.network = false;
		}
		this.setState({...this.state});
	}

	changeCollaborator(k, v) {
		this.state.already_selected_collaborator_network = false;
		if(_size(this.state.sweep.config.collaborations) > 0 && this.state.sweep.config.collaborations[v] != undefined) {
			//this.state.already_selected_collaborator_network = v;
		}

		this.state.options_collaborator[k] = v;
		this.setState({...this.state});
	}

	generateLink(cb) {
		$.post('/sweeps/generateLink/' + this.props.sweep.id, this.state.options_collaborator, (result) => {
			if(result.status) {
				this.state.options_collaborator['network'] = result.network;
				this.state.options_collaborator['link'] = result.link;
				this.setState({...this.state});
				window.handleClickSettings.receiveCollaboratorFromSidebar(this.state.options_collaborator);
			}
			if(cb != undefined) cb();
		}, 'JSON');
	}

	toggleMultipost() {
		this.state.display_multipost = !this.state.display_multipost;
		this.setState({...this.state});
	}

	togglePopupPayment(type) {
		if(type == undefined) type = false;

		this.state.popuppayment_option = type;
		this.state.popuppayment_type = false;
		switch(type) {
			case 'instagram_ad':
			case 'facebook_ad':
			case 'twitter_ad':
				this.state.popuppayment_type = 'ad';
				break;
			case 'multiple_posts':
				this.state.popuppayment_type = 'multiple';
				break;
		}

		this.state.display_popuppayment = !this.state.display_popuppayment;
		this.setState({...this.state});
	}

	toggleSponsoredInfo() {
		this.state.display_sponsored_info = !this.state.display_sponsored_info;
		this.setState({...this.state});
	}

	updatePosts(posts, type) {
		this.state.display_multipost = false;
		this.props.transferInformationToSweep(posts, type);
	}
	changeBrand(post,cb) {
		this.state.sweep.post_id[post.post_id].page = post.page;
		this.state.sweep.post_id[post.post_id].creator = post.creator;
		this.props.transferInformationToSweep({posts:this.state.sweep.post_id}, 'edit',cb);
	}

	componentDidMount() {
		var collaborator_sweep = false;
		var sweep = this.state.sweep;
		switch(this.state.type) {
			case 'settings':
			case 'success':
				break;

			case 'create':
			default:
				if(sweep != undefined && sweep.id != undefined) collaborator_sweep = true;
				break;
		}

		if(!(this.props.banners != undefined && !collaborator_sweep && !this.display_posts)) {
			const _container = document.querySelector('.profile_grid');
			_container.classList.remove('without_menu');
			_container.classList.add('with_sidebar');
		}
	}

	render() {
		const i18n = (m, c) => i18nIntl(m, this.props.intl, c);

		var sweep = this.state.sweep;
		if(sweep.number_of_posts == undefined) sweep.number_of_posts = 0;

		const post_id = this.props.post_id;

		const has_basic_subs = (this.props.has_basic_subs != undefined) ? this.props.has_basic_subs : false;
		const has_basicpro_subs = (this.props.has_basicpro_subs != undefined) ? this.props.has_basicpro_subs : false;

		var label_multipost = i18n("Selected posts");
		var label_view_posts = i18n("View");

		var label_instructions = i18n("Once you have selected all the posts you want to include in your giveaway, click on the Continue button.");
		var pro_sweet_text = i18n("Do you need to include promoted posts, ads or posts from other social networks or from collaborators?");

		var offer_multinetwork = (sweep.status == const_sweep.OPENED && sweep.type == const_sweep.TYPE_COMMENT) ? true : false;
		switch(sweep.network) {
			case const_sweep.ID_TWITTER:
				label_multipost = i18n("Selected tweets");
				pro_sweet_text = i18n("Do you need to include ads or posts from other social networks or from other collaborators?");
				break;
			case const_sweep.ID_YOUTUBE:
				pro_sweet_text = i18n("Do you need to include posts from other social networks or from other collaborators?");
				//label_multipost = i18n("Selected videos");
				break;
			case const_sweep.ID_LIST:
				label_instructions = i18n("Once you have uploaded / pasted all the entrants information you want to include in your giveaway, click on the Continue button");
				break;
			case const_sweep.ID_MULTI:
				offer_multinetwork = false;
				break;
		}

		/* Collaborators - ini */
		var collaborator_sweep = false;
		var show_invitation_collaborator = false;
		switch(this.state.type) {
			case 'settings':
				show_invitation_collaborator = (has_basicpro_subs && sweep.network == const_sweep.ID_MULTI) ? true : false;
				break;
			case 'success':
				break;
			case 'create':
			default:
				if(sweep != undefined && sweep.id != undefined) collaborator_sweep = true;
				break;
		}
		const is_multinetwork_without_posts = (sweep.network == const_sweep.ID_MULTI && this.state.type == 'create' && post_id.length == 0 && this.props.empty_enabled) ? true : false;

		const array_networks = [
			{ k:false, v:"-- " + i18n("Select a network") + " --" },
			{ k:const_sweep.ID_FACEBOOK, v:"Facebook" },
			{ k:const_sweep.ID_INSTAGRAM, v:"Instagram" },
			//{ k:const_sweep.ID_TWITTER, v:"Twitter" },//21/04/2023 => Twitter v1.1 OFF
		];

		var collaborations = [];
		if(sweep.config != undefined && _size(sweep.config.collaborations) > 0) {
			$.each(sweep.config.collaborations, function(i, item) {
				collaborations.push(item);
			});
		}
		/* Collaborators - end */

		var available_to_refresh = (sweep.network == const_sweep.ID_MULTI && sweep.status == const_sweep.OPENED) ? true : false;

		var max_items_to_select = 1;
		if(sweep.network == const_sweep.ID_MULTI) {
			max_items_to_select = const_sweep.MAX_POSTS_SELECTEDS_MULTI - sweep.number_of_posts;
		} else if(has_basicpro_subs || has_basic_subs) {
			max_items_to_select = const_sweep.MAX_POSTS_SELECTEDS - sweep.number_of_posts;

			if(sweep.type == const_sweep.TYPE_LEAD_ADS) max_items_to_select = 1 - sweep.number_of_posts;

		}

		const call_to_action_disabled = !this.props.enable_make_sweep;
		const call_to_action_highlighted = (!call_to_action_disabled && this.state.type == 'create') ? true : false;
		const call_to_action_color = (this.state.type == 'create') ? 'green' : 'blue';

		var createSweep = (this.state.type == 'create' && this.props.toggleConfirmation != undefined) ? this.props.toggleConfirmation : null;
		if(sweep.network!=const_sweep.ID_MULTI && createSweep!=null && this.state.type == 'create' && post_id.length > 0) {
			createSweep = this.props.make_sweep;
		}

		var banners_to_display = this.props.banners;
		if(sweep.type == const_sweep.TYPE_LIVE) {
			const kit_link = 'https://www.easypromosapp.com/docs/' + ((window.is_spanish) ? 'kit_easypromoslive_sorteo_en_evento' : 'kit_easypromoslive_giveaways_for_events') + '.pdf';
			const video_link = 'https://live.easypromosapp.com/' + ((window.is_spanish) ? 'sorteo-en-evento' : 'giveaways-for-events') + '/?utm_source=easypromos&utm_medium=panel&utm_campaign=sidebar';
			const tutorial_link = window.zendesk_base_url + '360028882012';
			banners_to_display = [{
				description:`<h2>${i18n("Giveaway for events", 'uppercase')}</h2><p>${i18n("Give out prizes during an event, conference or meeting. Thrill your audience with the suspense and excitement of a live contest.")}</p><p>${i18n("To take part, the audience must be able to see the screen where you project the contest instructions and a countdown.")}</p><p>${i18n("Viewers use their mobile phones to share their name and answer a few questions.")}</p><p>${i18n("When the countdown ends, the screen shows the results of the questions. These can be eliminatory, so that only users with correct answers enter the prize draw. Finally, the winners are selected at random. The screen displays the winners and prizes in Show Mode.")}</p><ul class='gui_checked_list gui_custom_icons gui_padded_in_top not_in_top'><li class='knk-arrow-r-big'><a href="${kit_link}" target="_blank" class=" submit_link in_top">${i18n("Get the Presenter's Kit")}</a></li><li class='knk-arrow-r-big'><a href="${video_link}" target="_blank" class=" submit_link in_top">${i18n("See it in action (video)")}</a></li><li class='knk-arrow-r-big'><a href="${tutorial_link}" target="_blank" class=" submit_link in_top">${i18n("Read tutorial")}</a></li></ul>`,
				end:'2100-12-31 00:00:00',
				id:'999999',
				start:'2000-01-01 00:00:00',
				status:'1',
				type:'html',
			}];
		}

		const story_giveaway = sweep.network == const_sweep.ID_INSTAGRAM && (sweep.type == const_sweep.TYPE_STORY_MENTION || sweep.type == const_sweep.TYPE_STORY_REPLYTO) ? true : false;

		if(this.props.banners != undefined && !collaborator_sweep && !this.display_posts) {
			return (
				<SweepSidebarBanners banners={banners_to_display} />
			)
		}

		let collaborator_links = [];
		if(collaborations.length > 0) {
			collaborations.map((item, i) => {
				const clickable = ((item?.used ?? false) === false) ? true : false;

				collaborator_links.push({
					label:{
						autotranslate:false,
						children:item.name_collaborator,
						_class:{ other:`ep-${item.network} blackIcon gui_small_icon gui_inline_block` },
					},
					_class:(item.network == this.state.already_selected_collaborator_network) ? { other:'gui_pulsing_animation' } : null,
					urls:[{
						url:item.link,
						clickable,
						enable_copy:clickable,
						actions:(!clickable) ? 
							<span class="knk-on greenIcon greenColor gui_small_icon gui_inline_block gui_not_in_start">{i18n("Used")}</span>
						 : null,
					}],
				});
			});
		}

		return (
			<div class="gui_sidebar_container">
				<aside class={'gui_sidebar_cart main_bg' + ((collaborator_sweep) ? ' is_collaborator_sweep' : '')}>
					<div>
						{(!collaborator_sweep && this.state.type == 'create') && (
							<p class="gui_only_as_sidebar" style={{lineHeight:'1.2em', flexShrink:0}}>{label_instructions}</p>
						)}
						{(this.state.type == 'create' && !this.props.list_enabled && sweep.network != const_sweep.ID_MULTI && !this.props.has_basic_subs && _size(post_id) > 0) && (
							<div>
								<Message
									_class={{ other:'in_top in_bottom'}}
								>
									<p><FormattedMessage id="{add_more} to the giveaway for {price} (cancel anytime)" values={{add_more:<ActionLink _href={window.panel_url+const_sweep.subscription_link_basic+'?multiple_posts'}>Add more organic posts</ActionLink>, price:this.props.pricebasic}} /></p>
									<p><ActionLink _href={window.zendesk_base_url + '207885566/#ideas'} _target="_blank">See some examples</ActionLink></p>
								</Message>
							</div>
						)}
						{(!story_giveaway) && (
							<ButtonCollection _class={{other:'gui_flex_end gui_flex_space_between'}}>
								<span class="gui_sided_to_button gui_not_in_end_tiny in_top gui_flexbox_auto gui_flex_row">
									{(this.state.type == 'create') ? (
										<span>{i18n("Selected")}: <strong>{post_id.length + '/' + max_items_to_select}</strong></span>
									) : (
										<span>{label_multipost}: <strong>{post_id.length}</strong></span>
									)}
									{(post_id.length > 0) && (
										<span class="gui_only_as_overlapped gui_not_in_start_small" style={{lineHeight:'1em'}}>[<ActionLink onClick={() => this.toggleAddedPostsInMobile(false)}>{label_view_posts}</ActionLink>]</span>
									)}
								</span>
								{(this.state.type == 'create' && !this.props.list_enabled) && (
									<ActionButton
										disabled={(call_to_action_disabled) ? true : false}
										_class={{color:((call_to_action_disabled) ? 'gray' : call_to_action_color), other:'gui_only_as_overlapped'+((call_to_action_highlighted) ? ' gui_beating_element' : '')}}
										onClick={() => this.toggleAddedPostsInMobile()}
									>Continue</ActionButton>
								)}
								{(this.state.type == 'create' && !this.props.list_enabled) && (
									<ActionButton
										disabled={(call_to_action_disabled) ? true : false}
										_class={{color:((call_to_action_disabled) ? 'gray' : call_to_action_color), other:'gui_only_as_sidebar'+((call_to_action_highlighted) ? ' gui_beating_element' : '')}}
										onClick={() => createSweep()}
									>Continue</ActionButton>
								)}
							</ButtonCollection>
						)}

						{(this.state.show_empty_create && is_multinetwork_without_posts) && (
							<FloatingLayer _class={{size:'small'}} enable_close={false}>
								<div>
									<SectionTitle>Giveaways in profiles you're not an admin of</SectionTitle>
									<SectionSubtitle>The Multi-Network Giveaway tool includes the collaboration system that allows you to create an invitation so that an administrator of a social media profile that you're not an administrator of can select the post and import the participants from the post to your giveaway without having to create an Easypromos account.</SectionSubtitle>
									<SectionSubtitle autotranslate={false}><ActionLink _href={window.zendesk_base_url + '360021643472'} _target="_blank">Tutorial on how to send an invitation to a collaborator</ActionLink></SectionSubtitle>
								
									<p style={{lineHeight:'1.2em',marginBlockEnd:'0.5em'}}><FormattedMessage id="{label} if your giveaway also includes a post from a profile you ARE an admin of. When you cancel, this window will close and you should first select the post you are an admin of. The giveaway will be created with your post and next, you can create the invitation for the collaborator." values={{label:<strong>{i18n("Cancel",'uppercase')}</strong>}}/></p>
									<p style={{lineHeight:'1.2em'}}><FormattedMessage id="{label} if the giveaway only includes posts that you ARE NOT an admin of. When you continue, the giveaway will be created and next, you can create the invitation for the collaborator." values={{label:<strong>{i18n("Continue",'uppercase')}</strong>}}/></p>

									<ButtonCollection in_floating={true}>
										<SecondaryButton
											onClick={() => this.setState({'show_empty_create':false})}
										>Cancel</SecondaryButton>

										<SaveButton
											onClick={() => createSweep()}
										>Continue</SaveButton>
									</ButtonCollection>
								</div>
							</FloatingLayer>
						)}

						{(post_id.length > 0 && this.props.uploaded_file_users == undefined) && (
							<div class="selected_posts_list">
								<ul class="gui_item_selector_post">
									{post_id.map((post, i) => {
										post.has_refresh = (available_to_refresh && post.network != const_sweep.ID_TWITTER && post.network != const_sweep.ID_YOUTUBE && post.is_ads == undefined) ? true : false;

										if(post.page == undefined) post.page = { name:sweep?.config?.name ?? (post?.creator ?? 'Unknown') };
										if(post.network == undefined) post.network = sweep.network;
										if(post.type == undefined) post.type = sweep.type;

										if(post.url != undefined && post.link == undefined) post.link = post.url;


										const is_linked = (post.link && post.link != '') ? true : false;

										return (
											<li key={'selected_'+i}>
												{(post.has_refresh && false) ? (
													<SweepPostSelected {...post} onRefresh={(i, cb) => this.refreshPost(i, cb)} delete={false} />
												) : (
													<SweepPostSelected {...post} is_linked={is_linked} type={this.state.type} delete={false} status={(sweep.status == const_sweep.OPENED) ? true : false }  onChange={(post, cb) => this.changeBrand(post, cb)} />
												)}
											</li>
										)
									})}
								</ul>
							</div>
						)}

						{(post_id.length == 0 && this.props.uploaded_file_users == undefined && !story_giveaway) && (
							<div class="selected_posts_list is_empty_preview">
								<ul class="gui_item_selector_post">
									<li><SweepPostSelected placeholder={true} /></li>
									<li><SweepPostSelected placeholder={true} /></li>
									<li><SweepPostSelected placeholder={true} /></li>
									<li><SweepPostSelected placeholder={true} /></li>
									<li><SweepPostSelected placeholder={true} /></li>
									<li><SweepPostSelected placeholder={true} /></li>
									<li><SweepPostSelected placeholder={true} /></li>
									<li><SweepPostSelected placeholder={true} /></li>
									<li><SweepPostSelected placeholder={true} /></li>
									<li><SweepPostSelected placeholder={true} /></li>
								</ul>
							</div>
						)}

						{(is_multinetwork_without_posts) && (
							<div class="additional_section gui_not_padded_in_top_small">
								<p class="gui_not_in_bottom_tiny" style={{lineHeight:'1.2em'}}><FormattedMessage id="If you want to select winners from posts published on profiles you're not an admin of, {link}." values={{link:<ActionLink onClick={()=>this.setState({'show_empty_create':true})}>click here</ActionLink>}}/></p>
							</div>
						)}

						{(offer_multinetwork) && (
							<div class="additional_section gui_only_as_sidebar">
								<Message
									icon={false}
									_class={{ other:'in_top in_bottom' }}
								>
									<div class="gui_pos_abs">
										<span class="with_pro_mark gui_not_in_end_tiny"><span class="is_pro_mark">{i18n("PRO")}</span></span>
									</div>
									<p class="gui_not_in_start_big">{pro_sweet_text}</p>
									<p class="gui_not_in_start_big"><ActionLink onClick={() => this.toggleSponsoredInfo()}>Use Multi-Network Giveaway</ActionLink></p>
								</Message>
							</div>
						)}

						{(show_invitation_collaborator) && (
							<div class="additional_section gui_not_padded_in_top_small gui_only_as_sidebar not_in_bottom">
								<p class="gui_not_in_bottom_tiny">{i18n("Invite your collaborators")}</p>

								<ButtonCollection>
									<MainButton
										onClick={() => this.toggleCollaborator()}
									>Create an invitation</MainButton>
								</ButtonCollection>
							</div>
						)}
					</div>
				</aside>

				{(this.state.display_collaborator) && (
					<FloatingLayer _class={{size:'small'}} backButton={() => this.toggleCollaborator()}>
						{(this.state.options_collaborator.link == '') ? (
							<div>
								<SectionTitle>Create an invitation</SectionTitle>
								<SectionSubtitle>Request access to posts from social profiles you are not an admin of to add them to the giveaway.</SectionSubtitle>
								<Model model={this.state.options_collaborator} change={(k, v) => this.changeCollaborator(k, v)}>
									{(sweep.network == const_sweep.ID_MULTI) && (
										<Select _class={{size:50, first:true}} name="network" values={array_networks}>Social network</Select>
									)}
									<Input _class={{size:50}} max_length={20}  name="name_collaborator">Name of collaborator</Input>
								</Model>

								{(_size(collaborations) > 0) && (
									<div class="gui_not_in_top_huge">
										<FieldLabel>Created invitations</FieldLabel>

										<LinkCollection
											items={collaborator_links}
											is_small={true}
										/>
									</div>
								)}

								<ButtonCollection in_floating={true}>
									<SaveButton
										disabled={(((this.state.options_collaborator.network == false || this.state.already_selected_collaborator_network != false) && sweep.network == const_sweep.ID_MULTI)  || this.state.options_collaborator.name_collaborator == '') ? true : false}
										onClick={(e, cb) => this.generateLink(cb)}
									>Continue</SaveButton>
								</ButtonCollection>
							</div>
						) : (
							<div>
								<SectionTitle>Link to share with your collaborator</SectionTitle>
								<SectionSubtitle>This is the link to share with the person who manages the social profile with the post you want to add. Once he/she has granted you access, that post will appear in the giveaways' list of posts and its participants will be added to the giveaway.</SectionSubtitle>

								<LinkCollection
									items={[{
										urls:[{
											url:this.state.options_collaborator.link,
										}]
									}]}
									_class={{ other:'gui_not_in_bottom_huge' }}
								/>

								<p class="gui_after_message"><strong>{i18n("Note")}:</strong>{' '+i18n("The collaborator does not need to have an Easypromos account")}</p>

								<ButtonCollection in_floating={true}>
									<SecondaryButton
										onClick={() => this.toggleCollaborator()}
									>Close</SecondaryButton>
								</ButtonCollection>
							</div>
						)}
					</FloatingLayer>
				)}

				{(this.state.display_sponsored_info) && (
					<FloatingLayer _class={{size:'normal'}} backButton={() => this.toggleSponsoredInfo()}>
						<div class="without_actions">
							{(sweep.network == const_sweep.ID_TWITTER && sweep.type == const_sweep.TYPE_RETWEET) && (
								<div>
									<SectionTitle>Promoted tweet</SectionTitle>
									<SectionSubtitle>To add a promoted tweet by URL you need to activate a Basic PRO Plan.</SectionSubtitle>
								</div>
							)}

							{(sweep.network != const_sweep.ID_TWITTER || sweep.type != const_sweep.TYPE_RETWEET) && (
								<div>
									<SectionTitle>Multi-Network Giveaway</SectionTitle>
									<SectionSubtitle autotranslate={false}>{i18n("Use this app to run giveaways with")}:</SectionSubtitle>

									<ul class="gui_checked_list gui_custom_icons gui_padded_in_top not_in_top">
										<li class="knk-arrow-r-big">{i18n("Facebook Ads (dark posts)")+", "+i18n("Instagram Ads or promoted posts")+" "+i18n("and")+'/'+i18n("or")+' '+i18n("Promoted Tweets")}</li>
										<li class="knk-arrow-r-big">{i18n("Users who commented on posts from different social networks")}</li>
										<li class="knk-arrow-r-big">{i18n("Posts from collaborators on social profiles that you are not an admin of")}</li>
									</ul>

									<SectionSubtitle>
										<FormattedMessage id="You'll need to use the {link_multinetwork} app." values={{link_multinetwork:<ActionLink _href={window.panel_url+'sweeps/create/multi/comment'}>Multi-Network Giveaway</ActionLink>}}/>
									</SectionSubtitle>
								</div>
							)}

							{(!has_basic_subs) && (
								<p class="not_in_top"><span class="with_pro_mark gui_not_in_end_tiny"><span class="is_pro_mark">PRO</span></span><FormattedMessage id="Only available with the {link_payment_basicpro}." values={{link_payment_basicpro:<ActionLink _href={window.panel_url+const_sweep.subscription_link_pro} _gaEvent={'buy_subs_basicpro_'+sweep.network+'_sponsored'}>Basic PRO Plan</ActionLink>}}/></p>
							)}
						</div>
					</FloatingLayer>
				)}

				{(this.state.display_added_posts_in_mobile) && (
					<FloatingLayer backButton={() => this.toggleAddedPostsInMobile()}>
						<div class={((this.state.type != 'create' || !this.state.enable_next_in_mobile_layer)) ? 'without_actions' : null}>
							<SectionTitle>Selected posts</SectionTitle>
							{(this.state.type == 'create' && this.state.enable_next_in_mobile_layer) && (
								<SectionSubtitle>Once you have selected all the posts you want to include in your giveaway, click on the Continue button.</SectionSubtitle>
							)}
							{(post_id.length > 0) ? (
								<div class="selected_posts_list gui_force_visible">
									<ul class="gui_item_selector_post">
										{post_id.map((post, i) => {
											var obj = post;
											obj.network = (obj.network == undefined) ? this.state.current_network : obj.network;
											const is_linked = (post.link && post.link != '') ? true : false;
											return (
												<li key={'selected_'+i}>
													<SweepPostSelected {...post} is_linked={is_linked} onClick={() => this.select(obj)} has_refresh={false} delete={((this.state.type == 'create') ? true : false)}></SweepPostSelected>
												</li>
											)
										})}
									</ul>
								</div>
							) : (
								<div>
									{i18n("There are no posts selected")}
								</div>
							)}

							{(offer_multinetwork && !this.state.enable_next_in_mobile_layer) && (
								<div class="additional_section not_in_top">
									<Message
										_class={{ other:'in_top in_bottom' }}
									>
										<div class="gui_pos_abs">
											<span class="with_pro_mark gui_not_in_end_tiny"><span class="is_pro_mark">{i18n("PRO")}</span></span>
										</div>
										<p class="gui_not_in_start_big">{pro_sweet_text}</p>
										<p class="gui_not_in_start_big"><ActionLink onClick={() => this.toggleSponsoredInfo()}>Use Multi-Network Giveaway</ActionLink></p>
									</Message>
								</div>
							)}

							{(show_invitation_collaborator && !this.state.enable_next_in_mobile_layer) && (
								<div class="additional_section gui_not_padded_in_top_small not_in_top">
									<p class="gui_not_in_bottom_tiny">{i18n("Invite your collaborators")}</p>

									<ButtonCollection>
										<MainButton
											onClick={() => this.toggleCollaborator()}
										>Create an invitation</MainButton>
									</ButtonCollection>
								</div>
							)}

							{(this.state.type == 'create' && this.state.enable_next_in_mobile_layer) && (
								<ButtonCollection in_floating={true}>
									<ActionButton
										disabled={(call_to_action_disabled) ? true : false}
										color={(call_to_action_disabled) ? 'gray' : call_to_action_color}
										onClick={() => { this.toggleAddedPostsInMobile(); createSweep(); }}
									>Continue</ActionButton>
								</ButtonCollection>
							)}
						</div>
					</FloatingLayer>
				)}
			</div>
		)
	}
}

export default injectIntl(SweepSidebar);